// extracted by mini-css-extract-plugin
module.exports = {"clientSection":"clientSection--no2tF","pagination":"pagination--FZ8iE","title":"title--7yB3F","list":"list--rV8Ql","listCount":"listCount--UkF60","listText":"listText--PzEQF"};